"use client";
import { createTheme } from "@mui/material/styles";
import { colors } from "@/app/theme/colors";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: {
      100: string;
      90: string;
      80: string;
      70: string;
      50: string;
      25: string;
      10: string;
    };
  }
  interface PaletteOptions {
    neutral?: {
      100: string;
      90: string;
      80: string;
      70: string;
      50: string;
      25: string;
      10: string;
    };
    tertiary: {
      main: string;
      light: string;
      dark: string;
    };
  }
}

// Create the theme
const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.base,
      light: colors.primary[200],
      dark: colors.primary[600],
      contrastText: "#FFFFFF",
      100: colors.primary[100],
      300: colors.primary[300],
      400: colors.primary[400],
      500: colors.primary[500],
      700: colors.primary[700],
    },
    secondary: {
      main: colors.secondary.base,
      light: colors.secondary[200],
      dark: colors.secondary[600],
      contrastText: "#FFFFFF",
      100: colors.secondary[100],
      300: colors.secondary[300],
      400: colors.secondary[400],
      500: colors.secondary[500],
      700: colors.secondary[700],
    },
    error: {
      main: colors.danger[400],
      light: colors.danger[200],
      dark: colors.danger[600],
      contrastText: "#FFFFFF",
      100: colors.danger[100],
      300: colors.danger[300],
      500: colors.danger[500],
      700: colors.danger[700],
    },
    success: {
      main: colors.success[300],
      light: colors.success[200],
      dark: colors.success[600],
      contrastText: "#FFFFFF",
      100: colors.success[100],
      400: colors.success[400],
      500: colors.success[500],
      700: colors.success[700],
    },
    grey: {
      100: colors.gray[100],
      200: colors.gray[200],
      300: colors.gray[300],
      400: colors.gray[400],
      500: colors.gray[500],
      600: colors.gray[600],
      700: colors.gray[700],
    },
    neutral: {
      100: colors.neutralShades[100],
      90: colors.neutralShades[90],
      80: colors.neutralShades[80],
      70: colors.neutralShades[70],
      50: colors.neutralShades[50],
      25: colors.neutralShades[25],
      10: colors.neutralShades[10],
    },
    tertiary: {
      main: colors.tertiary.base,
      light: colors.tertiary[100],
      dark: colors.tertiary[700],
    },
    background: {
      default: colors.app.main,
      paper: colors.app.card,
    },
  },
  typography: {
    fontFamily: "var(--font-roboto)",
    h6: {
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "27px",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            background: "#37383B",
            borderRadius: "8px",
            "&::-webkit-input-placeholder": {
              opacity: 1,
            },
            "&:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 100px #37383B inset",
              WebkitTextFillColor: "#ffffff",
              borderRadius: "8px",
            },
          },
          borderRadius: "8px",
          // borderBottom: "2px solid #64748B",
          "& .MuiFilledInput-root.Mui-focused": {
            color: "white !important",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "21px",
          },
          "& .MuiInputBase-root-MuiFilledInput-root.Mui-error::after": {
            borderBottomColor: "#F22828 ",
            borderRadius: "8px",
            margin: "0 auto",
            display: "flex",
            width: "99%",
          },
          "& .MuiInputBase-root-MuiFilledInput-root.Mui-error::before": {
            border: "none",
          },
          "& .MuiFilledInput-root::after": {
            borderBottomColor: "#64748B ",
            // borderRadius: "8px",
            margin: "0 auto",
            display: "flex",
            width: "99%",
          },
          "& .MuiFilledInput-root::before": {
            border: "none",
          },

          "& .MuiInputLabel-root.Mui-focused": {
            color: "#64748B",
          },
          "& .MuiInputLabel-root": {
            color: "#ffffff",
          },
        },
      },
    },
  },
});

export default theme;
